import _ from "lodash"
import { fromJS, OrderedSet } from "immutable"

import cuckoo from "common/services/cuckoo/cuckoo"
import { cuckooEvents } from "common/consts/enums"
import mapperManageBookingChange from "./mapperManageBookingChange"
import AdditionalService from "common/records/AdditionalService"
import {
  SERVICES,
  SERVICES_STATUSES,
  API_CATEGORIES_TO_SERVICES,
} from "mmb/consts/additionalServices"

const MAPPER = {
  // We don't care about `offer` as they are in `additionalBooking.details`
  pending: SERVICES_STATUSES.OFFERED,
}

export default function mapperAdditionalServices(input) {
  try {
    const mappedAdditionalServices = new OrderedSet(input.pending_additional_services || [])
      .map(service => {
        if (!API_CATEGORIES_TO_SERVICES[service.category])
          cuckoo.error(cuckooEvents.MMB_MAPPER_SERVICES_UNKNOWN_CATEGORY, {
            category: service.category,
          })
        return AdditionalService({
          id: service.id,
          category: API_CATEGORIES_TO_SERVICES[service.category]
            ? service.category
            : SERVICES.EXTRA,
          status: MAPPER[service.status],

          created: service.created * 1000,
          updated: service.updated * 1000,

          payment: {
            currency: service.currency,
            amount: service.price,
          },
          params: fromJS(service.data),
          description: service.description,
        })
      })
      .filter(service => Object.values(MAPPER).includes(service.status))

    const details = (input.additional_bookings && input.additional_bookings.details) || []

    const mappedAdditionalBookings = _.map(details, x => mapperManageBookingChange(x))

    return mappedAdditionalServices.concat(mappedAdditionalBookings)
  } catch (error) {
    cuckoo.error(cuckooEvents.MMB_ADDITIONAL_SERVICE_MAPPER_ERROR, { error })
    return null
  }
}
